module.exports = __webpack_public_path__ + "media/src/images/logo-dark-bg-b892351e99d5819157292465937fa4ee.png";